<template>
  <div>
    <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <div class="zj-left-main" style="width: 180px">
          <el-input
            v-model="deptName"
            placeholder="请输入部门名称"
            prefix-icon="el-icon-search"
          />
          <el-tree
            :data="deptOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
            default-expand-all
            @node-click="handleNodeClick"
          />
        </div>
      </div>
      <div class="zj-layout-right">
        <zj-layout-header>
          <el-form
            class="zj-search-form"
            ref="queryForm"
            :model="queryParams"
            :label-width="labelWidth"
          >
            <el-form-item label="用户名称" prop="userName">
              <el-input
                v-model="queryParams.userName"
                placeholder="请输入用户名称"
              />
            </el-form-item>
            <el-form-item label="手机号码" prop="phonenumber">
              <el-input
                v-model="queryParams.phonenumber"
                placeholder="请输入手机号码"
              />
            </el-form-item>
            <el-form-item label="状态" prop="status">
              <el-select v-model="queryParams.status" placeholder="用户状态">
                <el-option
                  v-for="dict in dict.type.permission_status"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item label class="right">
              <el-button @click="handleQuery">搜 索</el-button>
              <el-button @click="resetQuery">重 置</el-button>
              <el-button @click="handleAdd">新 增</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <el-table v-loading="loading" :data="userList">
                <el-table-column
                  label="用户编号"
                  align="center"
                  prop="userId"
                />
                <el-table-column
                  label="用户名称"
                  align="center"
                  prop="userName"
                />
                <el-table-column
                  label="用户昵称"
                  align="center"
                  prop="nickName"
                />
                <el-table-column
                  label="部门"
                  align="center"
                  prop="dept.deptName"
                />
                <el-table-column
                  label="手机号码"
                  align="center"
                  prop="phonenumber"
                  width="100"
                />
                <el-table-column
                  label="状态"
                  align="center"
                  prop="status"
                  width="70"
                >
                  <template slot-scope="scope">
                    <el-switch
                      v-model="scope.row.status"
                      active-value="0"
                      inactive-value="1"
                      @change="handleStatusChange(scope.row)"
                    ></el-switch>
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建时间"
                  align="center"
                  prop="createTime"
                ></el-table-column>
                <el-table-column label="操作" align="center" width="140">
                  <template slot-scope="scope">
                    <el-button
                      icon="el-icon-edit-outline"
                      type="text"
                      @click="handleUpdate(scope.row)"
                      >修改</el-button
                    >
                    <el-button
                      icon="el-icon-delete"
                      type="text"
                      @click="handleDelete(scope.row)"
                      >删除</el-button
                    >
                    <el-dropdown
                      size="mini"
                      @command="(command) => handleCommand(command, scope.row)"
                    >
                      <span class="el-dropdown-link">
                        <i class="el-icon-d-arrow-right el-icon--right"></i>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          command="handleResetPwd"
                          icon="el-icon-key"
                          >重置密码</el-dropdown-item
                        >
                        <el-dropdown-item
                          command="handleAuthRole"
                          icon="el-icon-user"
                          >分配角色</el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </zj-layout-main>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
          ></el-pagination>
        </zj-layout-footer>
      </div>
    </zj-layout-container>

    <!-- 添加或修改对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户昵称" prop="nickName">
              <el-input
                v-model="form.nickName"
                placeholder="请输入用户昵称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="deptId">
              <treeselect
                @select="selectDeptId"
                v-model="form.deptId"
                :options="deptOptions"
                :show-count="true"
                placeholder="请选择归属部门"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phonenumber">
              <el-input
                v-model="form.phonenumber"
                placeholder="请输入手机号码"
                maxlength="11"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input
                v-model="form.email"
                placeholder="请输入邮箱"
                maxlength="50"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              v-if="form.userId == undefined"
              label="用户名称"
              prop="userName"
            >
              <el-input
                v-model="form.userName"
                placeholder="请输入用户名称"
                maxlength="30"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="form.userId == undefined"
              label="用户密码"
              prop="password"
            >
              <el-input
                v-model="form.password"
                placeholder="请输入用户密码"
                type="password"
                maxlength="20"
                show-password
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户性别">
              <el-select v-model="form.sex" placeholder="请选择">
                <el-option
                  v-for="dict in dict.type.user_sex"
                  :key="dict.value"
                  :label="dict.label"
                  :value="dict.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色">
              <el-select
                v-model="form.roleIds"
                multiple
                placeholder="请选择"
                @change="refreshSelect"
              >
                <el-option
                  v-for="item in roleOptions"
                  :key="item.roleId"
                  :label="item.roleName"
                  :value="item.roleId"
                  :disabled="item.status == 1"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio
                  v-for="dict in dict.type.permission_status"
                  :key="dict.value"
                  :label="dict.value"
                  >{{ dict.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                v-model="form.remark"
                type="textarea"
                placeholder="请输入内容"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listUser,
  getUserById,
  addUser,
  updateUser,
  delUser,
  changeUserStatus,
  resetUserPwd,
} from "@/api/system/permission/user";
import { deptTreeData } from "@/api/system/permission/dept";
import { roleSelect } from "@/api/system/permission/role";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  name: "UserView",
  controller: "UI",
  action: "UserView",
  components: {
    Treeselect,
  },
  dicts: ["permission_status", "user_sex"],
  data() {
    return {
      // 遮罩层
      loading: true,
      // 部门名称
      deptName: "",
      // 部门树选项
      deptOptions: null,
      // 配置选项
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 用户表格数据
      userList: null,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        userName: "",
        phonenumber: "",
        status: "",
        pageNum: 1,
        pageSize: 10,
      },
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 角色选项
      roleOptions: [],
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        nickName: [
          { required: true, message: "用户昵称不能为空", trigger: "blur" },
          {
            pattern: "[^ \x22]+",
            message: "用户昵称不能为空",
            trigger: "blur",
          },
        ],
        deptId: [
          { required: true, message: "归属部门不能为空", trigger: "blur" },
        ],
        userName: [
          {
            required: true,
            message: "用户名称不能为空",
            pattern: "[^ \x22]+",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "用户名称长度必须介于 2 和 20 之间",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "用户密码不能为空",
            trigger: "blur",
          },
          {
            min: 5,
            max: 20,
            message: "用户密码长度必须介于 5 和 20 之间",
            trigger: "blur",
          },
        ],
        phonenumber: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        email: [
          { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur"],
          },
        ],
      },
    };
  },
  created() {
    this.getList();
    this.logInfo.ActionName = "用户管理查看";
    this.logInfo.LogMessage = "用户管理查看";
    this.logInfo.ModuleName = "账号管理";
    this.logInfo.PageName = "用户管理列表页面";
    this.addOperationLog();
    this.getTreeselect();
    this.getRoleSelect();
  },
  watch: {
    // 根据名称筛选部门树
    deptName(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    // 监听归属部门，取消验证
    selectDeptId() {
      this.$refs["form"].clearValidate("deptId");
    },
    // 查询部门下拉树结构
    getTreeselect() {
      deptTreeData().then((response) => {
        this.deptOptions = response.data;
      });
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.getList();
    },
    // 查询用户列表
    getList() {
      this.loading = true;
      listUser(this.queryParams).then((response) => {
        response.rows.forEach(element => {
          element.status = String(element.status);
        });
        this.userList = response.rows;
        this.total = parseInt(response.total);
        this.loading = false;
      });
    },

    // 搜索
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.deptName = "";
      this.queryParams.deptId = null;
      this.handleQuery();
    },
    // 新增
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加用户";
    },

    // 用户状态修改
    handleStatusChange(row) {
      //点击之后判断停用/启用
      let text = row.status == "0" ? "启用" : "停用";
      this.$confirm("确认要" + text + '"' + row.userName + '"用户吗？')
        .then(function () {
          return changeUserStatus({ userId: row.userId, status: row.status });
        })
        .then(() => {
          this.$message({ type: "success", message: text + "成功" });
        })
        .catch(() => {
          row.status = row.status === "0" ? "1" : "0";
        });
    },
    // 行修改
    handleUpdate(row) {
      this.reset();
      getUserById(row.userId).then((response) => {
        this.form = response.data.data;
        this.form.roleIds = response.data.roleIds;
        this.open = true;
        this.title = "修改用户";
      });
    },
    // 行删除
    handleDelete(row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return delUser(row.userId);
        })
        .then(() => {
          this.$message({ type: "success", message: "删除成功!" });
          this.logInfo.ActionName = "用户删除";
          this.logInfo.LogMessage = "用户删除成功";
          this.logInfo.ModuleName = "账号管理";
          this.logInfo.PageName = "用户管理列表页面";
          this.addOperationLog();
          this.getList();
        })
        .catch(() => {});
    },

    // 更多操作触发
    handleCommand(command, row) {
      switch (command) {
        case "handleResetPwd":
          this.handleResetPwd(row);
          break;
        case "handleAuthRole":
          this.handleAuthRole(row);
          break;
        default:
          break;
      }
    },
    // 重置密码
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        inputPattern: /^.{5,20}$/,
        inputErrorMessage: "用户密码长度必须介于 5 和 20 之间",
      })
        .then(({ value }) => {
          resetUserPwd({ userId: row.userId, password: value }).then(
            (response) => {
              this.$message({
                type: "success",
                message: "修改成功，新密码是：" + value,
              });
              this.logInfo.ActionName = "用户密码重置";
              this.logInfo.LogMessage = "用户密码重置成功";
              this.logInfo.ModuleName = "账号管理";
              this.logInfo.PageName = "用户管理列表页面";
              this.addOperationLog();
            }
          );
        })
        .catch(() => {});
    },
    // 分配角色
    handleAuthRole(row) {
      this.$router.push({
        path: "/plugin/permission/UI/UserRoleView",
        query: { userId: row.userId },
      });
    },

    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        nickName: null,
        deptId: null,
        userName: undefined,
        password: undefined,
        phonenumber: null,
        email: null,
        sex: null,
        roleIds: [],
        status: "0",
        remark: null,
      };
      this.resetForm("form");
    },
    // 角色选项
    getRoleSelect() {
      roleSelect().then((response) => {
        this.roleOptions = response.data.map((item) => {
          return {
            roleId: parseInt(item.roleId),
            roleName: item.roleName,
            status: item.status,
          };
        });
      });
    },
    // 下拉框强制刷新
    refreshSelect() {
      this.$forceUpdate();
    },
    //提交
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.form.userId != undefined) {
            updateUser(this.form).then((response) => {
              this.$message({ type: "success", message: "修改成功" });
              this.logInfo.ActionName = "用户修改";
              this.logInfo.LogMessage = "用户修改成功";
              this.logInfo.ModuleName = "账号管理";
              this.logInfo.PageName = "用户管理列表页面";
              this.addOperationLog();
              this.open = false;
              this.getList();
            });
          } else {
            addUser(this.form).then((response) => {
              this.$message({ type: "success", message: "新增成功" });
              this.logInfo.ActionName = "用户添加";
              this.logInfo.LogMessage = "用户添加成功";
              this.logInfo.ModuleName = "账号管理";
              this.logInfo.PageName = "用户管理列表页面";
              this.addOperationLog();
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },

    // 点击每页显示的条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    // 点击切换到某页
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
::v-deep .zj-layout-container.user-layout .zj-layout-right {
  min-width: 82%;
}
</style>
